import {
  COLLAPSE_HEADER,
  EXPAND_HEADER,
  TOGGLE_HEADER,
  SET_COLLAPSING,
  SET_STICKY,
  TOGGLE_MORE_INFO,
  TOGGLE_RELATED_PROJECTS,
  TOGGLE_RELATED_PROJECTS_SHOW_ALL
} from './constants'

import {
  SCROLL_TOP,
} from 'containers/Project/View/constants'

import { createReducer } from 'helpers/ReducerUtil'
import { combineReducers } from 'redux'

const collapse = createReducer(false, {
  [COLLAPSE_HEADER]: () => true,
  [EXPAND_HEADER]: () => false,
  [TOGGLE_HEADER]: (prev) => !prev,
  [SCROLL_TOP]: (prev, { isTop }) => !isTop
})

const collapsing = createReducer(false, {
  [SET_COLLAPSING]: (prev, { collapsing }) => collapsing
})

const sticky = createReducer(false, {
  [SET_STICKY]: (prev, { sticky }) => sticky
})

const moreInfoCollapse = createReducer(true, {
  [TOGGLE_MORE_INFO]: (prev) => !prev,
})

const showAll = createReducer(false, {
  [TOGGLE_RELATED_PROJECTS_SHOW_ALL]: (prev) => !prev
})

const relatedProjectsCollapse = createReducer(false, {
  [TOGGLE_RELATED_PROJECTS]: (prev) => !prev
})

const relatedProjects = combineReducers({
  collapse: relatedProjectsCollapse,
  showAll
})

export default combineReducers({
  collapse,
  collapsing,
  sticky,
  moreInfoCollapse,
  relatedProjects,
})
